var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:[{'filter brightness-0 invert' : _vm.white, 'filter grayscale' : _vm.dark}, _vm.icon_class],attrs:{"src":_vm.getIconPath()}})}
var staticRenderFns = []

export { render, staticRenderFns }